import React from 'react';
import { Code, Smartphone, Lightbulb } from 'lucide-react';
import AnimatedSection from '../components/AnimatedSection'

const servicios = [
  {
    titulo: 'Desarrollo de Software',
    descripcion: 'Soluciones a medida para empresas, sistemas web y más.',
    icono: <Code size={40} className="text-blue-600" />,
  },
  {
    titulo: 'Desarrollo de Apps Móviles',
    descripcion: 'Aplicaciones móviles para Android y iOS con gran experiencia de usuario.',
    icono: <Smartphone size={40} className="text-blue-600" />,
  },
  {
    titulo: 'Consultoría Tecnológica',
    descripcion: 'Asesoría estratégica para transformar digitalmente tu negocio.',
    icono: <Lightbulb size={40} className="text-blue-600" />,
  },
];

export default function Servicios() {
  return (
    <section id="servicios" className="py-20 bg-gray-50 px-4">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-10 text-gray-800">Nuestros Servicios</h2>
        <AnimatedSection>
            <div className="grid gap-8 md:grid-cols-3">
            {servicios.map((servicio, idx) => (
                <div key={idx} className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-all">
                <div className="mb-4 flex justify-center">{servicio.icono}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">{servicio.titulo}</h3>
                <p className="text-gray-600">{servicio.descripcion}</p>
                </div>
            ))}
            </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
